import { Action } from 'redux';
import _ from 'underscore';

import { Loadable } from '~src/httpClient/utils/Loadable';

import { UserNotificationSettingsState } from './state/UserNotificationSettingsState';
import { isGetUserNotificationSettingsAction, isGetUserNotificationSettingsFailedAction, isGetUserNotificationSettingsSucceededAction, isUpdateUserNotificationSettingsFailedAction, isUpdateUserNotificationSettingsSucceededAction } from './UserNotificationSettingsActions';

const initialState: UserNotificationSettingsState = {
  settings: Loadable.notLoaded
};

export function userNotificationSettingsReducer(
  prevState: UserNotificationSettingsState = initialState,
  action: Action = null
): UserNotificationSettingsState {
  if (isGetUserNotificationSettingsAction(action)) {
    return {
      ...prevState,
      settings: Loadable.loading()
    };
  } else if (isGetUserNotificationSettingsSucceededAction(action)) {
    return {
      ...prevState,
      settings: Loadable.loaded(action.settings)
    };
  } else if (isUpdateUserNotificationSettingsSucceededAction(action)) {
    const updated = action.updatedSettings;
    const prevSettings = prevState.settings.content.settings;
    const updatedSettings = prevSettings.map(setting => {
      let update = _.findWhere(updated, _.pick(setting, ['channel', 'notificationBucket']));
      let result = _.clone(setting);
      if (update) {
        result.enabled = update.enabled;
      }
      return result;
    });

    return {
      ...prevState,
      settings: Loadable.loaded({
        ...prevState.settings.content,
        settings: updatedSettings,
      })
    };
  } else if (isGetUserNotificationSettingsFailedAction(action) || isUpdateUserNotificationSettingsFailedAction(action)) {
    return {
      ...prevState,
      settings: Loadable.failed('')
    };
  } else {
    return prevState;
  }
}
